import { render, staticRenderFns } from "./Erc20TokenList.vue?vue&type=template&id=1f939b90&"
import script from "./Erc20TokenList.vue?vue&type=script&lang=js&"
export * from "./Erc20TokenList.vue?vue&type=script&lang=js&"
import style0 from "./Erc20TokenList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports